import { Pipe, PipeTransform } from '@angular/core';
import { DateUtil } from '../util/date.util';

@Pipe({
  name: 'fancyYearOnly'
})
export class FancyYearOnlyPipe implements PipeTransform {

  transform(value: number) {
    if (value != null && value > 0) {
      let date = new Date(value);
      return date.getFullYear();
    } else {
      return "0";
    }
  }

}
